module.exports = __webpack_public_path__ + "static/img/bangde.8ccf1e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prod_detail/bangde.jpg
// module id = RMbb
// module chunks = 1